import {
  LOADING_PRISTINE,
  LOADING_STARTED,
  LOADING_COMPLETED_SUCCESS,
  LOADING_COMPLETED_FAILURE,
  INIT_DATA_MODULE,
  GET_HTTP_CONFIG,
  GET_BACKEND_URL,
  GET_CURRENT_ROUTE,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX,
  GET_IDEA_COACH_STATE,
  SET_IDEA_COACH_STATE,
  IDEA_COACH_TYPE,
  A_UPDATE_IDEA_COACH_STATE,
  A_RESET_IDEA_COACH_STATE,
} from "../services/constants";
import http from "../services/axios";
import Vue from "vue";
import { ideaCoachConstructor } from "../services/utilities";

const store = {
  state: {
    question: ideaCoachConstructor(),
    answers: [
      ideaCoachConstructor(),
      ideaCoachConstructor(),
      ideaCoachConstructor(),
      ideaCoachConstructor(),
    ],
  },
  getters: {
    [GET_IDEA_COACH_STATE](state, getters) {
      if (getters[GET_CURRENT_ROUTE].path.includes("question")) {
        return state.question;
      } else {
        return state.answers[getters[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX]];
      }
    },
  },
  mutations: {
    [SET_IDEA_COACH_STATE](state, { payload, type, index }) {
      if (type === IDEA_COACH_TYPE.question) {
        state.question = Object.assign({}, state.question, payload);
      } else {
        const updateObj = Object.assign({}, state.answers[index], payload);
        Vue.set(state.answers, index, updateObj);
      }
    },
  },
  actions: {
    [A_UPDATE_IDEA_COACH_STATE]({ commit, getters }, payload) {
      if (getters[GET_CURRENT_ROUTE].path.includes("question")) {
        commit(SET_IDEA_COACH_STATE, { payload, type: IDEA_COACH_TYPE.question });
      } else {
        const index = getters[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX];
        commit(SET_IDEA_COACH_STATE, { payload, type: IDEA_COACH_TYPE.answer, index });
      }
    },
    [A_RESET_IDEA_COACH_STATE]({ commit }) {
      commit(SET_IDEA_COACH_STATE, {
        payload: ideaCoachConstructor(),
        type: IDEA_COACH_TYPE.question,
      });
      for (let i = 0; i < 4; i++) {
        commit(SET_IDEA_COACH_STATE, {
          payload: ideaCoachConstructor(),
          type: IDEA_COACH_TYPE.answer,
          index: i,
        });
      }
    },
  },
};

export default store;
export const ideaCoachModule = store;
